import { DetailedHTMLProps, InputHTMLAttributes, ReactNode, forwardRef, useId } from 'react';
import { describedBy } from '../fieldMessages';

interface Props extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label: ReactNode;
    errorMessage?: string;
    classNames?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, Props>(
    ({ label, errorMessage, classNames = '', id, 'aria-describedby': ariaDescribedBy, ...props }, ref) => {
        // Called unconditionally (rules of hooks); only used when the caller passes no id
        const generatedId = useId();
        id ||= generatedId;
        const errorId = `${id}-error`;
        return (
            <div className={`group relative w-full clear-both ${classNames}`}>
                <div className="flex">
                    <input
                        id={id}
                        type="checkbox"
                        className="form-check-input"
                        {...props}
                        aria-invalid={errorMessage ? true : undefined}
                        aria-describedby={describedBy(ariaDescribedBy, !!errorMessage && errorId)}
                        ref={ref}
                    />
                    <label htmlFor={id}>{label}</label>
                </div>
                {errorMessage && (
                    <p id={errorId} className="error-message">
                        {errorMessage}
                    </p>
                )}
            </div>
        );
    }
);
